import Laser from '../Image/Depi/laser.png'
import Rolon from '../Image/Depi/rolon.png'
import Español from '../Image/Depi/español.png'



const DataDepi = [
    {
        img: Laser,
        title: "Definitiva Laser",
        description: "Es una técnica que depila en forma rápida, eficaz y virtualmente indolora gracias a la revolucionaria tecnología Soprano  Ice Platinum  que con bajos niveles de energía producen un calentamiento progresivo de la dermis hasta una temperatura que daña el folículo piloso y previene el recrecimiento. ",
        duracion: "30 min"
    },
    {
        img: Rolon,
        title: "Sisitema Roll On",
        description: "La cera Roll On ha revolucionado el mercado en los centros de estética, se trata de una cera tibia que se puede aplicar en cualquier zona del cuerpo y rostro, apta para todo tipo de pieles, hasta las más sensibles, lo que garantiza una depilación segura.",
        duracion: "30 min"
    },
    {
        img: Español,
        title: "Sistema Español",
        description: "Consiste en calentar la cera y distribuirla sobre la superficie a depilar. Su uso disminuye la aparición paulatina del vello ya que lo extrae de raíz y mejora la textura de la piel con el paso del tiempo.",
        duracion: "30 min"
    }
]

export default DataDepi;